// determine the page title
export const renderPaymentTitle = (renderPayMentBoxes?: boolean | number) =>
  renderPayMentBoxes ? 'auth-head' : 'auth-head-auth'

// determine whether to display Upgrade or downgrade true for downgrade - false for upgrade
export const determineSubmitLabel = (
  currentPlan?: string,
  selectedPlan?: string
) => {
  if (currentPlan === selectedPlan) {
    return false
  }
  if (currentPlan && selectedPlan) {
    const proAcc = currentPlan[0] === 'H' || currentPlan[0] === 'L'

    const proUpgrade = currentPlan[0] === 'H' && selectedPlan[0] === 'L'
    const hobyDowngrade = proAcc && selectedPlan[0] === 'C'

    if (hobyDowngrade) {
      return true
    }

    if (proUpgrade) {
      return true
    }

    if (
      currentPlan[0] === selectedPlan[0] &&
      currentPlan[1] > selectedPlan[1]
    ) {
      return true
    }
  }
  return false
}
